export const CUSTOM_SIP_HEADER_MODES = {
    MAIN_TABLE: 'MainTable',
    ADD: 'Add',
    EDIT: 'Edit',
    DELETE: 'Delete',
    LOADING: 'Loading',
};

export const INITIAL_CUSTOM_SIP_HEADER_DATA = {
    name: '',
    suffix: '',
    customHeaderTypeID: '',
    linkID: '',
    value: '',
    visibleScope: 80,
    updateScope: 80,
};

export const FORM_FIELD_PATHS = {
    NAME: 'name',
    SUFFIX: 'suffix',
    CUSTOM_HEADER_TYPE_ID: 'customHeaderTypeID',
    LINK_ID: 'linkID',
    VALUE: 'value',
    VISIBLE_SCOPE: 'visibleScope',
    UPDATE_SCOPE: 'updateScope',
};
